
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';
import { MakeupFormAStudentForm, MakeupFormAStudentVo } from './makeupFormAStudentForm';

export class MakeupFormADownloadForm extends Form {
	private static _instance = new MakeupFormADownloadForm();

	students: ChildForm = {
		name:'students',
		form:MakeupFormAStudentForm.getInstance(),
		isEditable:false,
		isTabular:true,
		label:'',
		minRows:0,
		maxRows:0,
		errorId:null
	};

	public static getInstance(): MakeupFormADownloadForm {
		return MakeupFormADownloadForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();

		this.childForms = new Map();
		this.childForms.set('students', this.students);
		this.opsAllowed = {get: true, filter: true};
		this.keyFields = ["offeredSubjectId"];
	}

	public getName(): string {
		 return 'makeupFormADownload';
	}
}


export class MakeupFormADownloadFd extends FormData {
	constructor(form: MakeupFormADownloadForm, sa: ServiceAgent) {
		super(form, sa);
	}
	/**  this form has no editable fields. data nust be accessed as Vo and not through fd **/
}


export interface MakeupFormADownloadVo extends Vo {
	departmentName?: string, 
	name?: string, 
	offeredSubjectId?: number, 
	code?: string, 
	degreeId?: number, 
	students?: MakeupFormAStudentVo
}
